import { useRef } from 'react';
import { useState, useEffect, useCallback } from 'react';
import ArtworkGallery from '../components/ArtworkGallery';
import ErrorPage from '../components/ErrorPage';
import LoadingIndicator from '../components/LoadingIndicator';
import '../App.css';

export default function Artwork() {
    const galleryRef = useRef(null);
    const sliderRef = useRef(null);
    const [addMargin, setAddMargin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const scrollToGallery = () => {
        setAddMargin(true);
        setTimeout(() => {
            galleryRef.current?.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }, 100);
    };

    const scrollToSlider = () => {
        setAddMargin(false);
        sliderRef.current?.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
        });
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (isLoading) {
                setHasError(true);
                setIsLoading(false);
            }
        }, 25000);

        return () => clearTimeout(timeout);
    }, [isLoading]);

    const handleAllImagesLoaded = useCallback(() => {
        setIsLoading(false);
    }, []);

    const handleError = useCallback((error) => {
        setHasError(true);
        setIsLoading(false);
    }, []);

    if (hasError) {
        return <ErrorPage msg='Server Error' />;
    }

    return (
        <div className='artwork-container'>
            {
                isLoading && <LoadingIndicator />
            }
            <div style={{ display: isLoading ? 'none' : 'block' }}>
                <div className='slider' ref={sliderRef}>
                    <ArtworkGallery
                        isSlider={true}      
                        onAllImagesLoaded={handleAllImagesLoaded}
                        onError={handleError}
                    />
                </div>
                
                <div className='gallery-toggle-container'>
                    <button 
                        className='gallery-toggle-btn' 
                        onClick={scrollToGallery}
                    >
                        <i className="bi bi-arrows-expand h4"></i>
                    </button>
                </div>
                <div className={`gallery-section ${addMargin ? 'gallery-with-margin' : ''}`} ref={galleryRef}>
                    <ArtworkGallery 
                        isSlider={false}
                        onAllImagesLoaded={() => {}}
                        onError={handleError}
                    />
                    
                    <div className='gallery-toggle-container'>
                        <button 
                            className='gallery-toggle-btn' 
                            onClick={scrollToSlider}
                        >
                            <i className="bi bi-arrow-bar-up h4"></i>
                        </button>
                    </div>
                </div>
            </div>    
        </div>
    );
}